import { useMemo } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AdminApiClient } from './api/AdminApiClient'
import { AdminApiClientProvider } from './api/AdminApiClientContext'
import { AuthProvider } from './auth/AuthProvider'
import { ErrorBoundary } from './components/ErrorBoundary'
import { kApiBaseUrl } from './config'
import { AppRouter } from './router'

export function App() {
  const client = useMemo(
    () => new AdminApiClient({ baseUrl: kApiBaseUrl }),
    [],
  )
  const queryClient = useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            // Operator data changes constantly; cache aggressively
            // within a page view but refetch on focus so a stale
            // queue snapshot can't quietly mislead a triage decision.
            staleTime: 30_000,
            gcTime: 5 * 60_000,
            retry: 1,
          },
        },
      }),
    [],
  )
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AdminApiClientProvider client={client}>
          <BrowserRouter>
            <AuthProvider client={client}>
              <AppRouter />
            </AuthProvider>
          </BrowserRouter>
        </AdminApiClientProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}
